import React from 'react';
import styled, { css } from 'styled-components';

import HeaderSocial from './HeaderSocial';
import HeaderMenu from './HeaderMenu';
import HamburgerMenu from './HamburgerMenu';
import theme from '../../../style/theme';
import Logo from '../../UI/Img/LogoSVG/Logo';

const HeaderContainer = styled.div`
  height: 2rem;
`;

const StyledHeader = styled.header`
  background-color: #6bb951;
  position: relative;
  z-index: 2;
  ${props =>
    props.isFixed &&
    css`
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
    `};
`;

const InnerHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0rem 3rem 0rem 3rem;
  margin: 0 auto 0 auto;
  max-width: ${theme.maxContainer.lg};
`;

const HeaderImage = styled.a`
  display: block;
  padding-top: 0.3rem;
  flex: 1 0 100px;
  max-width: 120px;
  :focus {
    outline: none;
  }
`;

const HeaderNav = styled.nav`
  display: flex;
  align-items: center;
  ${props => {
    const { active, isPhone } = props;
    if (isPhone)
      return css`
        opacity: ${props.active ? 1 : 0};
        transform: ${props.active ? 'translateY(99%);' : 'translateY(0);'};
        flex-wrap: wrap;
        position: absolute;
        z-index: -1;
        bottom: 0;
        left: 0;
        width: 100%;
        background: #6bb951;
        box-shadow: 0 4px 4px rgba(0, 0, 0, 0.24);
        transition: 0.3s all ease;
      `;
  }};
`;

const HeaderNavStyle = styled.div`
  display: flex;
  margin: 0.3rem auto 0px auto;
`;

export class Header extends React.Component {
  state = {
    isOpen: false,
    isPhone: false,
    isFixed: false,
  };
  handleOpen = e => {
    e.preventDefault();
    this.setState(prevState => ({
      isOpen: !prevState.isOpen,
    }));
  };
  checkScroll = () => {
    this.setState({
      isFixed: false,
    });
    if (window.pageYOffset > document.getElementById('header').offsetTop) {
      this.setState({
        isFixed: true,
      });
    }
  };
  componentWillMount = () => {};
  componentDidMount = () => {
    window.addEventListener('scroll', this.checkScroll);
    if (window.innerWidth < 800) {
      this.setState({
        isPhone: true,
      });
    }
  };
  componentWillUnmount = () => {
    window.removeEventListener('scroll', this.checkScroll);
  };
  render() {
    const { menu, social } = this.props;
    return (
      <HeaderContainer>
        <StyledHeader isFixed={this.state.isFixed} id="header">
          <InnerHeader>
            <HeaderImage href="/" label="home">
              <Logo label="Logo da wquarks apontando para a página inicial" />
            </HeaderImage>
            <HeaderNav active={this.state.isOpen} isPhone={this.state.isPhone}>
              <HeaderNavStyle>
                {menu.map(item => <HeaderMenu key={item.name} {...item} />)}
              </HeaderNavStyle>
              <HeaderNavStyle>
                {social.map(item => <HeaderSocial key={item.icon} {...item} />)}
              </HeaderNavStyle>
            </HeaderNav>
            <HamburgerMenu
              active={this.state.isOpen}
              handleOpen={this.handleOpen}
              isPhone={this.state.isPhone}
            />
          </InnerHeader>
        </StyledHeader>
      </HeaderContainer>
    );
  }
}

export default Header;



// WEBPACK FOOTER //
// ./src/components/Index/Header/index.jsx